import { StudentHomeworkListPage } from "@/pages/teacher/StudentHomeworkListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/teacher/classrooms/$classroomId/students/$studentId/homework/"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { classroomId, studentId } = Route.useParams();
  return <StudentHomeworkListPage classroomId={classroomId} studentId={studentId} />;
}
